import { injectGlobal } from '@emotion/css'
import { theme } from './theme.js'

const injectGlobalStyles = () => {
  injectGlobal({
    '*, *::before, *::after': {
      boxSizing: 'border-box',
      margin: 0,
      padding: 0,
    },
    html: {
      fontSize: '16px',
      WebkitTextSizeAdjust: '100%',
      textSizeAdjust: '100%',
    },
    body: {
      fontFamily: theme.typography.fontFamily,
      backgroundColor: theme.colors.bg,
      color: theme.colors.text,
      lineHeight: theme.typography.lineHeight.normal,
      minHeight: '100vh',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
    },
    '#root': {
      minHeight: '100vh',
    },
    'a': {
      color: 'inherit',
      textDecoration: 'none',
    },
    'button': {
      fontFamily: 'inherit',
      cursor: 'pointer',
    },
    'input, textarea': {
      fontFamily: 'inherit',
    },
  })
}

export { injectGlobalStyles }
